import cs from './i18n/cs'
import da from './i18n/da'
import de from './i18n/de'
import en from './i18n/en'
import es from './i18n/es'
import fr from './i18n/fr'
import ja from './i18n/ja'
import nb from './i18n/nb'
import nl from './i18n/nl'
import pl from './i18n/pl'
import pt from './i18n/pt'
import ru from './i18n/ru'
import th from './i18n/th'
import zh from './i18n/zh_CN'

const fallbackLocale = 'en-US'

type SchemaType = typeof en

const enUS: SchemaType = en
const ruRU: SchemaType = ru
const frFR: SchemaType = fr
const deDE: SchemaType = de
const esES: SchemaType = es
const plPL: SchemaType = pl
const ptPT: SchemaType = pt
const jaJP: SchemaType = ja
const nlNL: SchemaType = nl
const daDK: SchemaType = da
const zhCN: SchemaType = zh
const thTH: SchemaType = th
const csCZ: SchemaType = cs
const nbNO: SchemaType = nb

type RecursiveKeyOf<TObj extends object> = {
  [TKey in keyof TObj & string]: TObj[TKey] extends any[]
    ? `${TKey}`
    : TObj[TKey] extends object
      ? `${TKey}` | `${TKey}.${RecursiveKeyOf<TObj[TKey]>}`
      : `${TKey}`
}[keyof TObj & string]

type LocalesMap = Record<string, SchemaType>

const localesMap: LocalesMap = {
  en: enUS,
  ru: ruRU,
  fr: frFR,
  de: deDE,
  es: esES,
  pl: plPL,
  pt: ptPT,
  ja: jaJP,
  nl: nlNL,
  da: daDK,
  zh: zhCN,
  th: thTH,
  cs: csCZ,
  nb: nbNO
}

type LocaleContent = {
  [key: string]: string | LocaleContent
}
class I18n {
  userLocale: string
  _locale!: string
  localeValues!: SchemaType

  constructor(defaultLocale: string) {
    this.userLocale = defaultLocale
  }

  set locale(val: string) {
    const locale = val || this.userLocale || fallbackLocale
    this._locale = locale

    const match = /([a-z]{2})(-[A-Z]{2,3})?/.exec(locale)?.[1]
    this.localeValues = match ? (localesMap[match] ?? enUS) : enUS
  }

  get locale() {
    return this._locale
  }

  t(key: RecursiveKeyOf<SchemaType>) {
    const keysSequence = key.toLowerCase().split('.')
    let res: string | LocaleContent = this.localeValues
    keysSequence.forEach((k: string) => {
      res = typeof res === 'string' ? res : res[k]
    })
    return res as unknown as string
  }
}

export default new I18n(navigator.language)
